import './styles/index.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import { AppProviders } from './app-providers.js';
import { startNetworkMonitor } from './offline/network.js';
import { bindInstallPrompt, registerServiceWorker } from './pwa/register-sw.js';
import { router } from './router.js';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Missing #root element in index.html');

createRoot(rootElement).render(
  <StrictMode>
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  </StrictMode>,
);

registerServiceWorker();
bindInstallPrompt();
startNetworkMonitor();
